
import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Grid,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from '@mui/lab';
import PropTypes from 'prop-types';

export default function DefaultCreateForm({
  open,
  onClose,
  register,
  errors,
  handleSubmit,
  watch,
  setValue,
  onSubmit,
  loading,
  recordId,
}) {
  const selectedType = watch('type') || 'invoice items';

  const handleFormSubmit = (formData) => {
    onSubmit({
      type: formData.type,
      Name: String(formData.Name || '').trim(),
      _id: recordId,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      fullWidth
      maxWidth="sm"
      aria-labelledby="invoice-default-dialog-title"
      PaperProps={{ sx: { borderRadius: 3, boxShadow: 24 } }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          px: 3,
          py: 2.5,
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <Box>
          <DialogTitle
            id="invoice-default-dialog-title"
            sx={{ p: 0, color: 'inherit', fontSize: '1.2rem', fontWeight: 600 }}
          >
            Edit Invoice Default
          </DialogTitle>

          <Typography variant="body2" sx={{ mt: 0.75, color: 'inherit', opacity: 0.85 }}>
            Update the item or tax code name.
          </Typography>
        </Box>

        <IconButton
          aria-label="Close dialog"
          onClick={onClose}
          disabled={loading}
          size="small"
          sx={{ color: 'inherit' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider />

      <Box
        component="form"
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit(handleFormSubmit)}
      >
        <DialogContent sx={{ px: 3, py: 3 }}>
          <Grid container spacing={2.5}>
            <Grid item xs={12}>
              <TextField
                select
                fullWidth
                label="Type"
                value={selectedType}
                disabled
                {...register('type')}
              >
                <MenuItem value="invoice items">Invoice Item</MenuItem>
                <MenuItem value="taxcode">Tax Code</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Name"
                placeholder="Enter name"
                {...register('Name', {
                  required: 'Name is required',
                  validate: (value) =>
                    Boolean(String(value || '').trim()) || 'Name is required',
                })}
                error={Boolean(errors?.Name)}
                helperText={errors?.Name?.message}
              />
            </Grid>
          </Grid>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 2.5, gap: 1 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={loading}
            sx={{ minWidth: 100 }}
          >
            Cancel
          </Button>

          <LoadingButton
            type="submit"
            variant="contained"
            loading={loading}
            sx={{ minWidth: 150 }}
          >
            Save Changes
          </LoadingButton>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

DefaultCreateForm.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  register: PropTypes.func.isRequired,
  errors: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  watch: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  recordId: PropTypes.string,
};
